<template>
  <v-card max-width="500">
    <v-card-title class="pa-2">
      <v-tabs v-model="tab" :key="tab" show-arrows centered height="40">
          <v-tabs-slider color="#ff5a10"></v-tabs-slider>
            <v-tab>Settings </v-tab>
            <v-tab>Kitchen Printer</v-tab>
        </v-tabs>
      <!-- <strong class="font-title-bold">Settings</strong> -->
      <v-spacer></v-spacer>
      <version/>
    </v-card-title>
    <v-divider></v-divider>
    <v-tabs-items v-model="tab">
    <v-tab-item :value="0" v-if="tab == 0">
    <v-card-text class="py-0 px-2">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12  class="px-3 pb-2">
            <v-switch
              color="success"
              v-model="settings.showTime.value"
              @change="savePreference()"
              hide-details
            >
              <div slot="label">{{ settings.showTime.label }}</div>
            </v-switch>
          </v-flex>
          <v-flex xs12  class="px-3 pb-2">
            <v-switch
              color="success"
              v-model="settings.store.value"
              @change="savePreference()"
              hide-details
            >
              <div slot="label">{{ settings.store.label }}</div>
            </v-switch>
          </v-flex>
          <v-flex xs12  class="px-3 pb-2">
            <v-switch
              color="success"
              v-model="settings.served.value"
              @change="savePreference()"
              hide-details
            >
              <div slot="label">{{ settings.served.label }}</div>
            </v-switch>
          </v-flex>
          <v-flex xs12 class="px-3 py-3">
            <v-layout row wrap>
              <v-flex xs12>
                <span class="subheading font-weight-bold"
                  >Summary Tab Width</span
                >
                <v-divider class="my-2"></v-divider>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="settings.width.limit[0]"
                  type="number"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs8 class="px-2">
                <v-slider
                  v-model="settings.width.value"
                  :max="settings.width.limit[1]"
                  :min="settings.width.limit[0]"
                  @change="savePreference()"
                  label=""
                ></v-slider>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="settings.width.value"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm6 class="px-3 py-2">
            <span class="subheading font-weight-bold">Theme</span>
            <v-divider class="my-2"></v-divider>
            <v-radio-group v-model="themeSelected" @change="changeTheme()" color="primary">
              <v-radio label="Light" :value="modes.light" color="primary"></v-radio>
              <v-radio label="Dark" :value="modes.dark" color="primary"></v-radio>
              <v-radio label="System Default" :value="modes.system" color="primary"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm6 class="px-3 py-2">
            <span class="subheading font-weight-bold">Notification</span>
            <v-divider class="my-2"></v-divider>
            <v-switch
              color="success"
              v-model="settings.enableNotification"
              @change="savePreference()"
              label="Enable Notification"
              hide-details
            >
            </v-switch>
            <v-switch
              color="success"
              v-model="settings.enableNotificationSound"
              @change="savePreference()"
              label="Enable Notification Sound"
              :disabled="!settings.enableNotification"
              hide-details
            >
            </v-switch>
          </v-flex>
        </v-layout>
        <v-layout class="py-3">
          <v-flex xs12 sm6 class="px-3 py-2">
            <span class="subheading font-weight-bold">Scroll Settings</span>
            <v-divider class="my-2"></v-divider>
            <v-checkbox
              v-model="settings.increaseScrollWidth"
              hide-details
              label="Increase Scroll Width"
              @change="savePreference()"
              color="primary"
            ></v-checkbox>
            <v-checkbox
              v-model="settings.showScrollControls"
              hide-details
              label="Show Scroll Contols"
              @change="savePreference()"
              color="primary"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    </v-tab-item>
    <v-tab-item :value="1" >
      <printer v-if="tab == 1"/>
    </v-tab-item>
  </v-tabs-items>
    <v-divider></v-divider>
    <v-card-actions class="py-2 px-3" v-if="tab == '0'">
      <v-btn small class="success" @click="hotReload()"> Reload </v-btn>
      <v-spacer></v-spacer>
      <v-btn outline small color="success" @click="reset()"> Reset </v-btn>
      <v-btn
        outline
        small
        color="error"
        @click="$emit('update:settings', false)"
      >
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { modes, THEME_MODE } from "@/vuex/theme";
import version from "@/components/utils/version.vue";
import printer from "@/components/printer";

export default {
  name: "Settings",
  components: {
    version,
    printer,
  },
  data() {
    return {
      themeSelected: 0,
      modes: modes,
      tab: 0,
    };
  },
  methods: {
    savePreference() {
      this.$store.commit("settings", this.settings);
    },
    reset() {
      this.$store.commit("resetSettings");
    },
    changeTheme() {
      this.$store.commit("setThemeMode", this.themeSelected);
    },
    hotReload() {
      this.$store.dispatch("connectCh");
      this.$store.commit("showSnackbar", {
        message: "Reloaded Successfully",
      });
    },
  },
  computed: {
    settings() {
      return this.$store.getters.nodeSettings;
    },
  },
  created() {
    this.themeSelected = modes.system;
    let theme = localStorage.getItem(THEME_MODE);
    if (theme) {
      this.themeSelected = JSON.parse(theme);
    }
  },
};
</script>
